<template>
    <div>
        <!-- Alerte aucune course selectionnée -->
        <div class="mb-4" v-if="warning_no_course_selected">
            <v-alert border="start" border-color="primary-dark">
                Attention, vous n'avez sélectionné aucun parcours.
                <span v-if="allow_inscription_non_sportive">En continuant vous aurez la possibilité de procéder à une
                    inscription non sportive, afin de réserver des options et/ou activités.</span>
            </v-alert>
        </div>
        <!-- Alerte aucune course disponible -->
        <div class="mb-4" v-if="warning_no_course_available">
            <v-alert border="start" border-color="primary-dark">Attention, il n'y a plus de parcours disponible pour
                cette évènement.
                <span v-if="allow_inscription_non_sportive">En continuant vous aurez la possibilité de procéder à une
                    inscription non sportive, afin de réserver des options et/ou activités.</span>
            </v-alert>
        </div>
        <div class="mb-4" v-if="warning_no_forfait_selected">
            <v-alert border="start" border-color="primary-dark">Attention, vous n'avez sélectionner aucun poste pour
                ce participant.</v-alert>
        </div>
    </div>
</template>
<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';

export default {
    props: ['warning_no_course_selected', 'warning_no_course_available', 'warning_no_forfait_selected', 'allow_inscription_non_sportive'],
    name: 'WarningBeforeContinue',
    computed: {
        ...mapStores(useMainStore),
    }

};
</script>



<style scoped></style>